function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlayerMovieSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00CC96"
    },
    cx: 255.95,
    cy: 255.95,
    r: 255.95
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#07B587"
    },
    d: "M509.923,223.123c1.351,10.803,2.077,21.71,2.077,32.928C512,397.426,397.426,512,256.052,512 c-11.115,0-22.126-0.727-32.928-2.077L81.957,368.756V143.347h348.189L509.923,223.123z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.85,
    y: 191.34,
    style: {
      fill: "#F7F7F8"
    },
    width: 348.19,
    height: 129.32
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M430.043,255.948v64.714H81.853v-64.714H430.043L430.043,255.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006775"
    },
    d: "M430.043,191.338v-47.991H81.853v47.991h40.096v129.325H81.853v47.99h348.189v-47.99h-40.096V191.338 H430.043z M290.539,153.423h28.566v25.969h-28.566V153.423z M361.381,191.338v129.325H151.45V191.338H361.381z M242.029,153.423 h28.566v25.969h-28.566V153.423z M193.519,153.423h28.566v25.969h-28.566V153.423z M145.009,153.423h28.566v25.969h-28.566V153.423z  M124.546,358.577H95.98v-25.969h28.566C124.546,332.608,124.546,358.577,124.546,358.577z M124.546,179.392H95.98v-25.969h28.566 C124.546,153.423,124.546,179.392,124.546,179.392z M173.368,358.577h-28.566v-25.969h28.566V358.577z M221.877,358.577h-28.566 v-25.969h28.566V358.577z M270.386,358.577H241.82v-25.969h28.566V358.577z M318.896,358.577H290.33v-25.969h28.566V358.577z  M367.406,358.577H338.84v-25.969h28.566V358.577z M367.613,179.392h-28.566v-25.969h28.566V179.392z M415.916,332.608v25.969 H387.35v-25.969H415.916z M387.557,179.392v-25.969h28.566v25.969H387.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E84F4F"
    },
    d: "M233.304,209.101l50.483,42.589c2.493,2.077,2.493,6.44,0,8.621L233.304,302.9 c-3.013,2.493-6.959,1.454-6.959-2.701c0-28.774,0-59.625,0-88.397C226.343,207.646,230.291,206.503,233.304,209.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA4545"
    },
    d: "M285.657,255.948c0,1.662-0.623,3.22-1.87,4.259l-50.483,42.589 c-3.013,2.493-6.959,1.454-6.959-2.701v-44.147H285.657L285.657,255.948z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayerMovieSvgrepoCom);
export default __webpack_public_path__ + "static/media/video-player-movie-svgrepo-com.a7a1e867b0d78242799cbb172e681677.svg";
export { ForwardRef as ReactComponent };